export default __webpack_public_path__ + "static/media/flecha-negra.b17759f7.png";